import { ChildType } from "@common/types/tree-types";

export const transformNodesTreeToFlatArray = (
  node: ChildType,
  result: any[] = [],
  parent?: any,
) => {
  const flattenedNode: any = { ...node, children: undefined, parent: parent };

  result.push(flattenedNode);

  if (node.children) {
    for (const child of node.children) {
      transformNodesTreeToFlatArray(child, result, flattenedNode); // Pass the current node as the parent
    }
  }

  return result;
};
